var active = null;

function toggleSearchBar(objToToggle) {
    if (objToToggle.classList.contains('displayNone')) {
        active = document.querySelector('li.active');
        if ( active != null ) {
            active.classList.remove('active');
        }
        objToToggle.classList.remove('displayNone');

        if ( typeof objToToggle.children[0] != 'undefined' && typeof objToToggle.children[0].children[0] != 'undefined' ) {
            objToToggle.children[0].children[0].focus();
        }
    } else {
        objToToggle.classList.add('displayNone');
        if ( active != null ) {
            active.classList.add('active');
            active = null;
        }
    }
}

var switch_open_close = 0;
function toggle_abo_selectbox (e) {
    if ( switch_open_close === 0 ) {
        $(this).addClass('blue');
        this.children[0].className = 'fa fa-angle-up';
        this.nextSibling.className = 'openHiddenContent';
        switch_open_close = 1 - switch_open_close;
    } else {
        $(this).removeClass('blue');
        this.children[0].className = 'fa fa-angle-down';
        this.nextSibling.className = '';
        switch_open_close = 1 - switch_open_close;
    }
}

function toggleMobileMenu($_this, nav_content_mobile) {
    if( $_this.className == 'navigation-close-button' ) {
        nav_content_mobile.className = 'headermenu smoothFadeOut';
        setTimeout(function(){
            nav_content_mobile.className = 'headermenu hide-navigation';
        }, 260);

    } else {
        nav_content_mobile.className = 'headermenu';
        setTimeout(function(){
            nav_content_mobile.className = 'headermenu smoothFadeIn';
        }, 100);
    }
}

function init_header() {
    if(document.cookie.match(/gemeinden_selected_value/)) {
        var pageId = document.cookie.match(/gemeinden_selected_value=(\d*)/)[1];
        if(pageId !== '') {
            $('.gemeinden').find('a').attr('href', '/?p=' + pageId );
        }
    }
    var searchButton = document.getElementsByClassName('search-icon'),
        inputToToggle = document.querySelector('form.search-form'),
        logoWrapper = document.querySelector('.logo-wrapper');

    var burger_navigation_button = document.getElementsByClassName('burger-menu')[0],
        navigation_close_button = document.getElementsByClassName('navigation-close-button')[0],
        nav_content_mobile = document.querySelector('nav.headermenu.hide-navigation') || false,
        selectbox_abo = document.querySelectorAll('nav .selectbox-wrapper .selected-value');

    // Logo wird absolute positioniert
    if ( logoWrapper != null && logoWrapper.classList.contains('absolute') ) {
        var posTop = logoWrapper.dataset.posTop,
            posLeft = logoWrapper.dataset.posLeft;

        logoWrapper.style = 'top: '+posTop+'px; left: '+posLeft+'px;';
    }

    if ( selectbox_abo.length >= 1 ) {
        for(i = 0; i < selectbox_abo.length; i++) {
            selectbox_abo[i].addEventListener('click', toggle_abo_selectbox );
        }
    }

    if ( typeof burger_navigation_button != 'undefined' ) {
        // open/close mobile navigation
        burger_navigation_button.addEventListener('click', function () {
            toggleMobileMenu(this, nav_content_mobile);
        });
        navigation_close_button.addEventListener('click', function () {
            toggleMobileMenu(this, nav_content_mobile);
        });

        searchButton[0].addEventListener('click', function () {
            toggleSearchBar(inputToToggle);
        });
        searchButton[1].addEventListener('click', function () {
            toggleSearchBar(inputToToggle);
        });
    }
}

if (document.addEventListener) {
    document.addEventListener('DOMContentLoaded', init_header, false);
} else {
    window.onload = function () {
        init_header();
    };
}

window.addEventListener('resize', function() {
    if ( window.innerWidth > 800 && typeof nav_content_mobile != 'undefined' ) {
        nav_content_mobile.className = 'headermenu hide-navigation';
    }
});

// Sticky header
(function () {
    $('.main-header').each(function(){
        var $header = $(this),
            $placeholder = $('.main-header-placeholder'),
            $nav = $header.find('.desktop-navigation'),
            headerHeight = $header.outerHeight(),
            headerOffsetInitial = $header.offset().top,
            navOffsetInitial = headerOffsetInitial + $nav.offset().top,
            stickyClass = 'main-header--sticky',
            scrollClass = 'main-header--document-scrolled';

        // Desktop header height is 60px and menu height is 44px => 16px difference
        if (window.screen.width > 1023) {
            navOffsetInitial -= 16;
        }

        $header.find('.bgPicture img').on('load', function () {
            $header.removeClass(stickyClass);
            $header.removeClass(scrollClass);
            headerHeight = $header.outerHeight();
            headerOffsetInitial = $header.offset().top;
            navOffsetInitial = headerOffsetInitial + $nav.offset().top;
            // Desktop header height is 60px and menu height is 44px => 16px difference
            if (window.screen.width > 1023) {
                navOffsetInitial -= 16;
            }
            $(window).trigger('header-height-changed');
        });

        $(window).on('scroll load header-height-changed', function() {
            var currentScroll = $(document).scrollTop();

            if (currentScroll > headerOffsetInitial) {
                $header.addClass(scrollClass);
            } else {
                $header.removeClass(scrollClass);
            }

            if (currentScroll >= navOffsetInitial) {
                $placeholder.height(headerHeight);
                $header.addClass(stickyClass);
            } else {
                $placeholder.height(0);
                $header.removeClass(stickyClass);
            }
        });
    });
})();

